//moment
import Moment from "moment";
//helper
import Util from "@/helper/Utility.js";

export function BurnPointConfigModel() {
    this.byConfig = true;
    this.config = 'purchase';
    this.top = 25;
    this.skip = 0;
    this.startdate = null;
    this.enddate = null;
    this.q = null;
    this.cat = null;
    this.sponsorId = null;
    this.center = null;

    this.getParams = function() {
        var params = {
            config: this.config,
            byConfig: this.byConfig,
            top: this.top,
            skip: this.skip,
            startdate: this.startdate,
            enddate: this.enddate,
            q: this.q,
            cat: this.cat,
            sponsorId: this.sponsorId,
            center: this.center
        };

        return Util.cleanObjectNullKey(params);
    };
}

export function BurnPointConfigBuilder() {
    this.burnPointConfig = new BurnPointConfigModel();

    this.create = function() {
        return this.burnPointConfig;
    };

    this.setConfig = function(config) {
        this.burnPointConfig.config = config;
        this.burnPointConfig.byConfig = true;
        return this;
    };

    this.setTop = function(top) {
        this.burnPointConfig.top = top;
        return this;
    };

    this.addSkip = function() {
        this.burnPointConfig.skip += this.burnPointConfig.top;
        return this;
    }
    this.setSkip = function(skip) {
        this.burnPointConfig.skip = skip;
        return this;
    };

    this.setStartDate = function(year, month) {
        this.burnPointConfig.startdate = year && month
            ? `${year}-${month}-01T00:00:00`
            : null;
        return this;
    };

    this.setEndDate = function(year, month) {
        if (year && month) {
            var lastDay = Moment(`${year}-${month}-01`).endOf('month').get('date');
            this.burnPointConfig.enddate = `${year}-${month}-${lastDay}T23:59:59`;
        } else {
            this.burnPointConfig.enddate = null;
        }
        return this;
    };

    this.setSearch = function (q) {
        this.burnPointConfig.q = q;
        return this;
    }

    this.setCatId = function (catId) {
        this.burnPointConfig.cat = catId
        return this;
    };

    this.setSponsorId = function (sponsorId) {
        this.burnPointConfig.sponsorId = sponsorId;
        return this;
    };

    this.setCenter = function (center) {
        this.burnPointConfig.center = center;
        return this;
    };
}
